import { Component, Input, Inject, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { ErrorState } from '../../_services/error-state/error-state.service';
import { Navigation } from 'src/app/_utlis/navigateToLanding';
import { StorageService } from 'src/app/Core/_services/storage/storage.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-inline-error-status',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './inline-error-status.component.html',
  styleUrl: './inline-error-status.component.scss',
})
export class InlineErrorStatusComponent {
  @Input() error: ErrorState | null = null;

  isSeller: boolean = false;
  isBrowser: boolean;
  isDev: boolean = (environment as any).isDev || false;
  showDevDetails: boolean = false;

  constructor(
    private storageService: StorageService,
    private nav: Navigation,
    @Inject(PLATFORM_ID) private platformId: any
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    this.isSeller =
      this.storageService.userData && this.storageService.userData?.is_seller;
  }

  /**
   * Get the error title translation key based on status code
   */
  getErrorTitle(): string {
    if (!this.error) return 'error_inline.title';

    switch (this.error.statusCode) {
      case 400:
        return 'error_inline.400_title';
      case 401:
        return 'error_inline.401_title';
      case 403:
        return 'error_inline.403_title';
      case 404:
        return 'error_inline.404_title';
      case 500:
        return 'error_inline.500_title';
      case 502:
      case 503:
      case 504:
        return 'error_inline.service_unavailable_title';
      default:
        return 'error_inline.title';
    }
  }

  /**
   * Toggle dev details visibility
   */
  toggleDevDetails(): void {
    this.showDevDetails = !this.showDevDetails;
  }

  /**
   * Navigate to landing page
   */
  navigateToLandingPage(): void {
    this.nav.NavigateToLanding();
  }

  /**
   * Format dev details as JSON string for display
   */
  formatDevDetails(): string {
    if (!this.error?.devDetails?.error) return 'No error details available';
    try {
      return JSON.stringify(this.error.devDetails.error, null, 2);
    } catch {
      return String(this.error.devDetails.error);
    }
  }
}
